module.exports = __webpack_public_path__ + "static/quartier_K-0cbd0dffca733b57beb6b40885507a35.png";